import * as React from 'react';
import { useState, useEffect } from 'react';
import useAuth from '../../../features/hooks/useAuth';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import styled from 'styled-components';
import moment from 'moment';
import { Span } from '../../../Styles/CommonStyles';
import { Chip } from '@mui/material';
import nameStringFn from '../../../data/nameStringFn';
import fetchPDF from '../../../data/fetchPDF';
import PdfModal from '../../../data/pdfmodal';



const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const SPAN = styled.div`
  cursor: pointer;
  color:blue;
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.th`
  text-align: left;
  padding: 8px;
`;

const TableCell = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
`;

export default function MyConsumModal({consumDetailmodalopen,consumDetailModaldata, handleConsumDetailModalClose, users}) {

  const Auth = useAuth();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedfile, setSelectedFile] = useState(null);
  
  // Get auth token for API requests
  const token = useSelector(state => state.auth.token);



  const handleviewdoc = () =>{
    window.open(URL.createObjectURL(selectedfile), '_blank');
  }
  const  closeModal = () =>{
    setModalIsOpen(false);
  }
  const pdffetcher = async () =>{
    const file =await fetchPDF(consumDetailModaldata, token);
    setSelectedFile(file);
  }

  const fields = consumDetailModaldata? [
    { label: 'OrderNo', value: consumDetailModaldata.orderno},
    { label: 'Category', value: consumDetailModaldata.category },
    { label: 'Consumable', value: consumDetailModaldata.consumable },
    { label: 'Model/OEM', value: consumDetailModaldata.oem },
    { label: 'Part No', value: consumDetailModaldata.partno },
    { label: 'Vendor', value: consumDetailModaldata.vendor },
    { label: 'Order Quantity', value: consumDetailModaldata.order_quantity },
    { label: 'Purchase Store', value:consumDetailModaldata.pur_store},
    { label: 'Current Store', value: consumDetailModaldata.cur_store },
    { label: 'Unit Price', value:consumDetailModaldata.unit_price },
    { label: 'Purchase Date', value:moment(consumDetailModaldata.purchase_date).format("DD/MM/YYYY")}, 
    { label: 'Warranty Exp Date', value:moment(consumDetailModaldata.warrantyexp_date).format("DD/MM/YYYY") },
    { label: 'Installation Date', value:moment(consumDetailModaldata.installation_date).format("DD/MM/YYYY") },
    Object.values(Auth.roles).flat(3).includes("level1approver") || Object.values(Auth.roles).flat(3).includes("level2approver") || Object.values(Auth.roles).flat(3).includes("Admin") ? { label: 'Unit Price', value:`₹ ${consumDetailModaldata.unit_price}` }:null,
    { label: 'Last Tranasaction Date', value: consumDetailModaldata.last_trans_date?.length?  moment(consumDetailModaldata.last_trans_date).format("DD/MM/YYYY"):"Not Available"},
    { label: 'Ledger Refrence', value: consumDetailModaldata.ledge_ref },
    { label: 'Bill Reference', value: consumDetailModaldata.bill_ref},
    { label: 'Remarks', value: consumDetailModaldata.remarks },
    { label: 'All Final Transactions', value: ""},
    { label: 'All InTransit Transactions', value: ""},
    { label: 'Add Status', value: consumDetailModaldata.addstatus},
    { label: 'Contract Document', value: consumDetailModaldata?.pdfPath?.length? <SPAN onClick={handleviewdoc}>Click here to view Document</SPAN>: "Not Available"} 
  ]:[];

  useEffect(() =>{
    pdffetcher();
  },[])
  console.log(selectedfile)
  return (
    <React.Fragment>
      <Dialog  onClose={handleConsumDetailModalClose} aria-labelledby="customized-dialog-title" open={consumDetailmodalopen} maxWidth="md">
        <DialogTitle>
          <Span>User Details</Span>
        </DialogTitle>
          <DialogContent dividers>
            <ModalContent>
              <Table>
              <tbody>
              {fields.filter(x => x?.label?.length).map((item, index)=>
                 <tr id='email' key ={index}>
                    <TableCell>
                      <TableHeader>
                        {item?.label}
                      </TableHeader>
                    </TableCell>
                    
                    {item?.label === "Specification"?<TableCell>
                    { item?.value.map((elm, ind)=><Chip sx={{margin:"2px"}} key={ind} label = {`${elm[0]}: ${elm[1]}`} />)}
                    </TableCell>:

                     <TableCell>
                      { item?.value}
                    </TableCell>}
                  </tr>
                )
              }              
            </tbody>
                  </Table>
            </ModalContent>
          </DialogContent>
            <DialogActions >
              <Button onClick={handleConsumDetailModalClose}>Close</Button>
            </DialogActions>
      </Dialog>
      <PdfModal
        show = {modalIsOpen}
        onClose = {closeModal}
        pdfUrl = {selectedfile? URL.createObjectURL(selectedfile) : null}
      />
      </React.Fragment>
  );
}
